export default __webpack_public_path__ + "static/media/icon_close.0b69e403.svg";